import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { RouterModule } from '@angular/router';

import { PromisedPaymentStatusEnum } from '../../../../modules/advance-application/models/promised-payment-status.enum';
import { PrequalifyStatusEnum } from '../../../../modules/authentication/models/v1-api.interface';
import { CurrencyJsPipe } from '../../../../modules/pipes/currency-js.pipe';
import { DatePipe } from '../../../../modules/pipes/date.pipe';
import { LocalisePipe } from '../../../../modules/pipes/localise.pipe';
import { IBalance } from '../../../../modules/shared/models/balance.interface';
import { Day } from '../../../../modules/shared/models/day.type';
import { MakePaymentDialogBalanceDTO } from '../../models/api-make-payment-dialog-balance.dto';
import { IDashboardStatePayment } from '../../models/dashboard-state.interface';

@Component({
  selector: 'app-dashboard-payment-block',
  templateUrl: './dashboard-payment-block.component.html',
  styleUrls: ['./dashboard-payment-block.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    LocalisePipe,
    CurrencyJsPipe,
    DatePipe,
    MatButton,
  ],
})
export class DashboardPaymentBlockComponent {
  @Output()
  addDeal = new EventEmitter<void>();

  @Output()
  schedulePaymentForNextDeal = new EventEmitter<void>();

  @Output()
  schedulePaymentForPastDeal = new EventEmitter<void>();

  @Output()
  editPayment = new EventEmitter<number>();

  @Output()
  updateClosingDate = new EventEmitter<void>();

  @Output()
  transferMoney = new EventEmitter<void>();

  @Input()
  public prequalifyStatus: PrequalifyStatusEnum;

  @Input()
  public hidePaymentWidget?: boolean;

  @Input()
  public fullBalanceInfo?: IBalance;

  @Input()
  public nextPromisedPayment?: IDashboardStatePayment;

  @Input()
  public prevPromisedPayment?: IDashboardStatePayment;

  @Input()
  public paymentDueBalance?: MakePaymentDialogBalanceDTO;

  @Input()
  public showPrequalifyInfo: boolean;

  @Input()
  public isNextPaymentIsDue: boolean;

  @Input()
  public isWithdrawWithoutCredit: boolean;

  @Input()
  public isNextDraftDeal: boolean;

  @Input()
  public isPaymentPastDue: boolean;

  @Input()
  public isNextPaymentIsScheduled: boolean;

  @Input()
  public isScheduledPaymentWasDue: boolean;

  @Input()
  public isGracePeriodDeal: boolean;

  @Input()
  public gracePeriodDay: Day;

  @Input()
  public deleting: boolean;

  @Input()
  public isDarkTheme: boolean;

  public readonly prequalifyStatusEnum = PrequalifyStatusEnum;
  public readonly promisedPaymentStatusEnum = PromisedPaymentStatusEnum;
}
